import { inject, Injectable } from '@angular/core';
import { bufferPromise } from '@df/util/fn/buffer-promise.fn';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import { ICmsEditorConfig } from './icms-editor-config';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';

@Injectable()
export class ICmsEditorConfigService {
    private iCmsConfigResource = inject(ICmsConfigResource);

    /**
     * Config entry
     */
    private model?: ICmsConfig<ICmsEditorConfig.IModelData>;

    async load() {
        this.model = await this.iCmsConfigResource.retrieve({ bareUrl: ICmsEditorConfig.configId }, undefined);
    }

    get config(): ICmsEditorConfig.IConfigContent {
        return this.model!.data!.content;
    }
}
